import React, { ComponentProps } from 'react'
import { NoteRoot } from './Note.styles'

type NoteOwnProps = ComponentProps<typeof NoteRoot>
export type NoteProps = NoteOwnProps & {}

export const Note = ({ children, ...rest }: NoteProps) => {
  return <NoteRoot {...rest}>{children}</NoteRoot>
}

Note.displayName = 'Note'
